import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, IconButton, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { ConfirmEnrollMixBundleBox } from './style';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';
import { IDialog } from '@interfaces/common';

interface Props {
  dialog: IDialog;
  handleConfirmEnrollBundle: () => void;
}

const ConfirmEnrollMixBundleModal = ({ dialog, handleConfirmEnrollBundle }: Props) => {
  const { t } = useTranslation('common');
  const theme = useTheme();
  return (
    <ConfirmEnrollMixBundleBox>
      <Box className="close-box">
        <IconButton onClick={dialog.close}>
          <CloseIcon style={{ color: theme.palette.grey[400] }} />
        </IconButton>
      </Box>
      <Box className="content-box">
        <FontAwesomeIcon
          style={{ fontSize: '50px' }}
          color={theme.palette.grey[500]}
          icon="fa-light fa-circle-exclamation"
        />
        <Typography className="title-text" color="primary.main" variant="h3">
          {t('confirm_enroll_bundle.title')}
        </Typography>
        <Typography className="detail-text" variant="body1">
          {t('confirm_enroll_bundle.detail')}
        </Typography>
        <Box className="button-box">
          <Button
            onClick={dialog.close}
            sx={{ width: '120px', fontWeight: 500, fontSize: '18px' }}
            variant="outlined"
            color="primary"
          >
            {t('confirm_enroll_bundle.cancel')}
          </Button>
          <Button
            onClick={handleConfirmEnrollBundle}
            sx={{ width: '120px', fontWeight: 500, fontSize: '18px' }}
            variant="contained"
            color="primary"
          >
            {t('confirm_enroll_bundle.confirm')}
          </Button>
        </Box>
      </Box>
    </ConfirmEnrollMixBundleBox>
  );
};

export default ConfirmEnrollMixBundleModal;
